<script setup>
import { useAttrs, useListeners } from 'vue';
import { tableRecipe } from './table.recipe';
import { useTableContext } from './useTable';

const { row } = tableRecipe();
const { rootProps } = useTableContext();

const attrs = useAttrs();
const listeners = useListeners();
</script>

<template>
  <tr
    data-component="CsTableRow"
    :class="row(rootProps)"
    v-bind="attrs"
    v-on="listeners"
  >
    <slot />
  </tr>
</template>
